require([
	'jquery',
	'root/Base/Js/MbiImageSize',
	'root/Base/Js/MbiMediaQuery',
	'validate',
	'masonry',
	'flickity',
	'debounce',

	'root/Base/Js/MbiBrowser',
	'root/Base/Js/Vendor/PictureFill',
	'root/Assets/Js/Templates',
	'root/Base/Js/Vendor/Modernizr',
	'root/Assets/Js/Vendor/cookie'

], function(
	$,
	mbiImageSize,
	mbiMq,
	validate,
	Masonry,
	Flickity
	) {

	'use strict';
	setTimeout(function() {
		mbiImageSize.init();
	}, 50);

	/*===================================================
	=            newsletter anmeldung footer            =
	===================================================*/

	validate.validateForm('newsletter-form-id');
	$(document).on('click', '.js_submitNewsletter', function(e) {
		e.preventDefault();
		if ($('#newsletter-form-id').valid()) {
			if (!$(this).hasClass('is_locked')) {
				$(this).addClass('is_locked');
				var form = $('.newsletter-form').serializeArray();
				// console.log(form);
				$.ajax({
					type: 'POST',
					data: {
						form: form,
						action: 'nl_registration'
					},
				})
				.done(function(data) {
					// console.log("success");
					$('.email').val('').attr('placeholder', 'Vielen Dank!');
					$('.email').val('').prop('disabled', true);
				})
				.fail(function() {
					// console.log("error");
				})
				.always(function() {
					// console.log("complete");
					$(this).removeClass('is_locked');
				});
			}
		}
	})

	/*=========================================
	=            contact from 		         =
	=========================================*/

	validate.validateForm('contact-form-id');
	$(document).on('click', '.js_submitQuestion', function(e) {
		e.preventDefault();
		if ($('#contact-form-id').valid()) {
			if (!$(this).hasClass('is_locked')) {
				$(this).addClass('is_locked');
				var dankemsg = $(this).attr('data-dankemsg');
				var dankeheadline = $(this).attr('data-dankeheadline');
				var form = $('.contact-form').serializeArray();
				// console.log(form);
				$.ajax({
					type: 'POST',
					data: {
						form: form,
						action: 'contact_form'
					},
				})
				.done(function(data) {
					// console.log("success");
					$('.section-ContactForm').html('<div class="dankeheadline">' + dankeheadline + '</div><div class="dankemsg">' + dankemsg + '</div>');

					// $('.email').val('').attr('placeholder', 'Vielen Dank!');
					// $('.email').val('').prop('disabled', true);
				})
				.fail(function() {
					// console.log("error");
				})
				.always(function() {
					// console.log("complete");
					$(this).removeClass('is_locked');
				});
			}
		}
	})



//MASONRY

function initMasonry() {
	if ($('.js_grid').length) {

		if ('phone-' in mbiMq.mqArea) {

			if (typeof Masonry.data($('.js_grid')[0]) !== 'undefined') {
				var msnry = Masonry.data($('.js_grid')[0]);
				msnry.destroy();
			}

		} else {
			var elem = document.querySelector('.js_grid');
			// if (typeof Masonry.data($('.js_grid')[0]) !== 'undefined') {
			// 	// var msnry = Masonry.data($('.js_grid')[0]);
			// 	// msnry.reloadItems()
			// } else {
				var msnry = new Masonry( elem, {
				  // options
				  itemSelector: '.js_grid-item',
				  columnWidth: '.grid-sizer',
				  gutter: 60
				});
			// }

		}
	}
}
initMasonry();






//INTRO ANIMATION
if($('.section-StartAnimation').length) {
	setTimeout(function() {
		$('.section-StartAnimation .site-title').addClass('transition');
		$('.after-animation .text-small').addClass('transition');
		$('.after-animation .text-big').addClass('transition');
		$('.after-animation .more-button').addClass('transition');
		$('.after-animation .svg-wrapper').addClass('transition');
	}, 100);

	setTimeout(function () {

		var lines = $('#a_paragraph').html().split('<br>');
		var a_paragraph = "";
		for(var i = 0; i < lines.length; i++) {
			a_paragraph += '<span class="line line-' + i + '">';
			a_paragraph += lines[i];
			a_paragraph += '</span>';
		}
		$('#a_paragraph').html(a_paragraph);

		var time = 300;

		setTimeout(function() {
			$('#a_paragraph').addClass('invisible');
			$('.section-StartAnimation').addClass('orange');
			$('.section-StartAnimation .site-title').addClass('show');
			$('.after-animation .text-small').addClass('show');
			$('.after-animation .text-big').addClass('show');
			$('.after-animation .more-button').addClass('show');
			$('.after-animation .svg-wrapper').addClass('show');
		}, 1200+(time*lines.length));

		$('.line').each( function() {
			var line = $(this);
			setTimeout(function() {
				line.addClass('strikethrough');
			}, time);
			time += 300;
		});

		setTimeout(function() {
			$('.after-animation .more-button').removeClass('transition');
		}, 3600 + time);

	}, 2500);
}

$('#intro-arrow').on('click', function(e) {
	e.preventDefault();
	var $ele = $(this).closest('.section').next();
	$('html,body').animate({scrollTop: $ele.offset().top - 80},'slow');
});

/*=========================================
=            fachgebiete magic            =
=========================================*/

$(document).on('click', '.js_openFachgebiet', function(){

	openFachgebiet($(this));

});

function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}



function openFachgebiet($ele){
	resetFachgebiete();
	var $nextInfoDesk = $ele.nextAll('.info-desk').first();
	var id = $ele.attr('data-infoid');
	var infoForHeight = $('.infoFor[data-infofor="' + id + '"]').outerHeight();
	var $this = $ele;

	$ele.addClass('is_active');

	$('.infoFor[data-infofor="' + id + '"]').addClass('is_active');
	$nextInfoDesk.addClass('is_active');
	$nextInfoDesk.css('max-height', infoForHeight + 100);


	if ('tablet+' in mbiMq.mqArea) {
		$nextInfoDesk.prev().addClass('border-bottom');
		$nextInfoDesk.prev().prev().addClass('border-bottom');
		$nextInfoDesk.prev().prev().prev().addClass('border-bottom');
	}

	setTimeout(function() {
		$('html, body').animate({
			scrollTop: $this.offset().top
		}, 200);
	}, 500);
}

$(document).on('click', '.js_closeFachgebiet', function(){
	resetFachgebiete();
})

$(document).on('click', '.js_scrollTopFachgebiet', function(){
	$('html, body').animate({
		scrollTop: $(this).closest('.info-desk').offset().top
	}, 400);
})

// function scrollToFixer(el1, el2){
// 	var wanted = el1;
// 	var got = el2;

// 	var wantedOff = wanted.offset().top;
// 	var gotOff = got.offset().top;
// 	if (gotOff > wantedOff) {
// 		// setTimeout(function() {
// 			$('html, body').animate({
// 				scrollTop: wanted.offset().top
// 			}, 200);
// 		// }, 500);
// 	} else {
// 		setTimeout(function() {
// 			$('html, body').animate({
// 				scrollTop: got.offset().top
// 			}, 200);
// 		}, 500);
// 	}
// }

function resetFachgebiete(){
	// console.log('fachgebiete reset');
	$('.js_openFachgebiet').removeClass('is_active');
	$('.js_openFachgebiet').removeClass('border-bottom');
	$('.info-desk').removeClass('is_active');
	$('.info-desk').removeAttr('style');
	$('.infoFor').removeClass('is_active');

}

function rearrange(action){
	resetFachgebiete();
	if (action == 'init') {
		if ('handheld-' in mbiMq.mqArea) {
			$('.js_openFachgebiet').each(function(){
				var id = $(this).attr('data-infoid');
				var info = $('.infoFor[data-infofor="' + id + '"]');
					info.wrap('<div class="info-desk info-desk-mob"></div>');
					info.parent().detach().insertAfter($(this));
					// $('span.info-desk').remove();
					// $('.info-desk:not(.info-desk-mob)').remove();
			});
			$('span.info-desk').each(function(){
				$(this).remove();
			})
		}
	} else {
		if ($('.info-desk.info-desk-mob').length > 0 ) { // from mob to desk
			if ('handheld-' in mbiMq.mqArea) {
				// return;
			} else {
				var tbl = $('.teilbereich').length;
				$('.teilbereich').each(function(i){
					var index = i+1;
					if (tbl == index || index % 3 == 0) {
						$(this).next().after('<span class="info-desk"></span>');
					}
				});
				$('.infoFor').each(function(){
					var $nextInfo = $(this).parent().nextAll('.info-desk:not(.info-desk-mob)').first();
					var detached = $(this).detach();
					$nextInfo.append(detached);
				})

				$('.info-desk.info-desk-mob').each(function(){
					$(this).remove();
				})
			}
		} else {
			if ('handheld-' in mbiMq.mqArea) {
				$('.js_openFachgebiet').each(function(){
					var id = $(this).attr('data-infoid');
					var info = $('.infoFor[data-infofor="' + id + '"]');
						info.wrap('<div class="info-desk info-desk-mob"></div>');
						info.parent().detach().insertAfter($(this));
						// $('span.info-desk').remove();
						// $('.info-desk:not(.info-desk-mob)').remove();
				});
				$('span.info-desk').each(function(){
					$(this).remove();
				})
			} else {
				// return;
			}
		}
	}
var fachgebietRequest = getParameterByName('fachgebiet', window.location.href);
// if (fachgebietRequest.legnth > 0) {
if (fachgebietRequest) {
openFachgebiet($('.teilbereich-' + fachgebietRequest));
}
}

// function detectResize

rearrange('init');


/*================================
=            flickity            =
================================*/

function initSliders(action)	{
	if ($('.slider').length) {

        $('.slider').each(function(){

            var id = $(this).attr('id');

            if ('lap-' in mbiMq.mqArea) {
                var actOpt = {
                    contain: true,
                    prevNextButtons: false,
                    cellAlign: 'left',
                    pageDots: false,
                    wrapAround: true,
                    groupCells:1
                }
            } else {
                var actOpt = {
                    contain: true,
                    // percentPosition: true,
                    prevNextButtons: false,
                    // setGallerySize: false,
                    // adaptiveHeight: true,
                    cellAlign: 'left',
                    // cellAlign: leftOffset / sliderWidth,
                    pageDots: false,
                    wrapAround: true,
                    groupCells:1
                }
            }

            if (action == 'reload') {
                var flkty = Flickity.data(id)
                flkty.destroy();
            }

            initSlider(id, actOpt);
        })
	}
}

initSliders('init');

$(window).resize($.debounce(250, function() {
	// console.log('do vielleicht?');
	initSliders('reload');
    mbiImageSize.init();
    if (!$('html').hasClass('ios') || !$('html').hasClass('ios')) {
    	rearrange('reload');
    }
    initMasonry();
    // console.log('jojo');
}));


function initSlider(e, o){
    // var elem = document.querySelector(e);
	var elem = document.getElementById(e);
	var options = {};
	if (o != undefined) {
		options = o;
	} else {
		options = {
			cellAlign: 'left',
			contain: true,
			// accessibility: false,
			percentPosition: true,
			autoPlay: 5000,
			// freeScroll: true,
			prevNextButtons: false,
			setGallerySize: true,
			// adaptiveHeight: true,
			pageDots: false,
			wrapAround: true,
		}
	}

	setTimeout(function() {
		var flkty = new Flickity( elem, options);

		// var $prevB = $(elem).parent().next().find('.button-prev');
		// var $nextB = $(elem).parent().next().find('.button-next');

		var $prevB = $(elem).closest('.section').find('.button-prev');
		var $nextB = $(elem).closest('.section').find('.button-next');
		var buttons = [$prevB, $nextB];

		var event = 'click';
		$.each( buttons,function(index, el) {
			$(el).unbind(event);
			$(el).on(event, function(evt) {
				evt.stopPropagation();
				evt.preventDefault();
				// console.log(event);
				if ($(this).hasClass('button-next')) {
					flkty.next(true, false);
				} else {
					flkty.previous(true, false);
				}
			});
		});

	}, 100);
    // setTimeout(function() {
    //     mbiImageSize.init();
    // }, 150);

}



/*==============================================
=            open close mobile menu            =
==============================================*/

$(document).on('click', '.js_openMobMenu', function(){
	if ($(this).hasClass('is-active')) {
		$(this).removeClass('is-active');
		$('#topnav').removeClass('is_open');
	} else {
		$(this).addClass('is-active');
		$('#topnav').addClass('is_open');
	}
})
$(document).on('click', '.js_mobSub', function(e){
	// e.preventDefault();
	if ('portrait-' in mbiMq.mqArea) {

		var subHeight = $(this).find('.menu-items-sub').outerHeight();

		if ($(this).hasClass('is_open')) {
			$(this).removeClass('is_open');
			$(this).removeAttr('style');
		} else {
			$(this).addClass('is_open');
			$(this).css('padding-bottom', subHeight+5);
		}
	}
})

$('.sub-hider').each(function(){
	if ('portrait-' in mbiMq.mqArea) {
		var $menu_items_sub = $(this).next().next();
		var subHeight = $menu_items_sub.outerHeight();
		$(this).css('height', subHeight)
	}
});

/*=====================================
=            hover submenu            =
=====================================*/

$(document).on('mouseenter', '.menu-items-sub', function(){
	$(this).prev().addClass('is_hover');
})

$(document).on('mouseleave', '.menu-items-sub', function(){
	$(this).prev().removeClass('is_hover');
})



/*==============================================
=            pagination        				   =
==============================================*/

function letsgo(elem, wrapper, mode){
	var page = elem.attr('data-page');

	// console.log(page);
	var wrap = wrapper;
	// $('.loading-screen').addClass('is_active');
	$.ajax({
		type: 'POST',
		dataType: 'json',
		data: {
			action: mode,
			contentpage: page
		},
	})
	.done(function(data) {
		// console.log('success');

		// $(document).find(wrap).html(data.content);

		// $(document).find('.essay-wrapper').html(data.content);
		$('.' + wrap).html(data.content);
		// wrap.html(data.content);



		// $('.'+wrap).html(data.content);
		// $('.section-NewsOverview').html(what.content);
		// $('.section-NewsOverview').html(content);

		var $url = data.url;

		history.pushState({
				'url': 			$url,
				'title': 		data.title,
				'origin': 		location.href,
				'content': 		data.content,
				'mode': 		'history'
			}, data.title, $url);

		setTimeout(function(){
			mbiImageSize.init();
			initMasonry();
		},100);
		// console.log(data);

		// $('html, body').animate({
	 //        scrollTop: $(".section-NewsOverview").offset().top
	 //    }, 1000);
	})
	.fail(function(error) {
		// console.log(error);
		// window.location = window.location + '?newspage=' + page;
		// console.log("error - reload");
	})
	.always(function() {
		// console.log("complete");
	});

}


$(document).on('click','.js_loadmore', function(){
	var wrapper = $(this).attr('data-wrapper');
	var mode = $(this).attr('data-mode');
	var elem = $(this);
	letsgo(elem, wrapper, mode);
});



$(window).on('popstate', function(event) {
	if(history.state){//for #anchor klicks
		if(history.state.content){
			var content = history.state.content;
			$('.section-NewsOverview').html(content);
			setTimeout(function(){
				mbiImageSize.init();
			},100)
		}
	}
});

/*==============================================
=            egi	        				   =
==============================================*/
function setGetParameter(url, paramName, paramValue)
{
    var url = url;
    var hash = location.hash;
    url = url.replace(hash, '');
    if (url.indexOf(paramName + "=") >= 0)
    {
        var prefix = url.substring(0, url.indexOf(paramName));
        var suffix = url.substring(url.indexOf(paramName));
        suffix = suffix.substring(suffix.indexOf("=") + 1);
        suffix = (suffix.indexOf("&") >= 0) ? suffix.substring(suffix.indexOf("&")) : "";
        url = prefix + paramName + "=" + paramValue + suffix;
    }
    else
    {
    if (url.indexOf("?") < 0)
        url += "?" + paramName + "=" + paramValue;
    else
        url += "&" + paramName + "=" + paramValue;
    }
    // console.log(url + hash);
    return url + hash;
    // window.location.href = url + hash;
}


$(document).on('click', '.category-button', function() {
	$('.category-button').removeClass('is_on');
	$(this).addClass('is_on');
})

$(document).on('click', '.js_catswitch', function() {
	// window.history.pushState({}, '', "/" + $('.site').attr('data-baseURL'));
	var type = $(this).attr('data-type');
	var newloc = setGetParameter(window.location.href, 'type', type);
	var pageone = setGetParameter(newloc, 'contentpage', 1);
	window.location.href = pageone;
	// console.log(newloc);
	// window.location = newloc;
})

	$(document).on('click', '.js_closeSticky', function() {
	$('.stickySiteButton').addClass('hideSticky');
})

/*=============================
=    partner detail seite     =
=============================*/

	$('.section-Awards .more-button').on('click', function() {
		$('.awards-list p').slideDown('slow');
		$(this).slideUp('slow');
	});

	$('.section-Publications .more-button').on('click', function() {
		$('.publication').slideDown('slow');
		$(this).slideUp('slow');
	});

	$('.scroll-up svg').on('click', function() {
		$("html, body").animate({ scrollTop: 0 }, "slow");
	});

	$('.partner-nav-link').on('click', function(e) {
		e.preventDefault();
		var dest = $(this).attr('href');
		$('html,body').animate({scrollTop: $(dest).offset().top - 120},'slow');
	});

	var saved_height = 0;

	//Sticky nav if > landscape
	$(document).on('scroll', function() {
		if ($('#partner-nav').length) {
			//console.log(saved_height);
		    if($(this).scrollTop() >= ($('#partner-nav').position().top - $('#partner-nav').height())){
		    	if(saved_height == 0) {
		    		saved_height = $('#partner-nav').position().top - $('#partner-nav').height();
		    	}
		        $('#partner-nav').addClass('sticky');
		        $('#partner-nav').next().addClass('push-down');
		    }

		    if($(this).scrollTop() <= saved_height) {
		    	//console.log('over');
		    	$('#partner-nav').removeClass('sticky');
		    	$('#partner-nav').next().removeClass('push-down');
		    }
		}
	});

	//Scrollspy

	$(window).scroll(function() {
	    var winTop = $(this).scrollTop();
	    var winBottom = winTop + $(window).height();
	    var $divs = $('.section');

	    var top = $.grep($divs, function(item) {
	    	var item_bottom = $(item).position().top + $(item).height() - 160;
	    	var item_top = $(item).position().top - 160;
	        return item_top <= winTop && item_bottom >= winTop;
	    });
	    var top_id = $(top).attr('id');
	    //console.log(top_id);
	    $('.partner-nav-link').each(function(){
	    	var href = $(this).attr('href').replace('#', '');
	    	if(href == top_id) {
	    		$(this).addClass('active');
	    	} else {
	    		$(this).removeClass('active');
	    	}
	    });
	});

});

define("Assets/Js/Footer.js", function(){});

